import { createContext, useEffect } from "react";

const FreshpaintContext = createContext(null);

interface Props {
  children: React.ReactNode;
}

const FreshpaintProvider = ({ children }: Props) => {
  useEffect(() => {
    if (!import.meta.env.PROD) return;

    const key = import.meta.env.VITE_FRESHPAINT_KEY;

    if (window.freshpaint && window.freshpaint.__loaded) return;

    (function () {
      const sdk = document.createElement("script");
      sdk.src = `https://freshpaint-cdn.com/js/${key}/freshpaint.js`;
      sdk.async = true;
      sdk.onload = () => {
        freshpaint.init(key, { autotrack: true });
        freshpaint.page();
      };
      document.head.appendChild(sdk);
    })();
  }, []);

  return (
    <FreshpaintContext.Provider value={null}>
      {children}
    </FreshpaintContext.Provider>
  );
};

export default FreshpaintProvider;
